import type { TablePaginationConfig } from 'antd/es/table/interface'

export const PAGINATED_LIST_TABLE_SIZE = 'middle' as const
export const PAGINATED_LIST_PAGE_SIZE_OPTIONS = [
    '10',
    '20',
    '50',
    '100',
]

export const buildPaginatedListPagination = (
    pagination: TablePaginationConfig
): TablePaginationConfig => ({
    ...pagination,
    showSizeChanger: true,
    pageSizeOptions: PAGINATED_LIST_PAGE_SIZE_OPTIONS,
})
